<template>
	<v-main>
        <!-- <v-container> -->
           <!--  <v-toolbar elevation="0">
				<v-btn icon color="primary" @click="$router.push('/')">
					<v-icon>mdi-home</v-icon>
				</v-btn>
				<v-toolbar-title class="font-weight-light">{{ $vuetify.lang.t('$vuetify.' + title) | capitalize }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar> -->

			<v-data-table
				v-model="selected"
				:headers="headers"
				:items="items"
				item-key="id"
				show-select
				:search="search"
				:loading="loading"
				loading-text="Завантаження даних... зачекайте, будь ласка."
				sort-by="id"
				sort-desc
				:items-per-page="itemsPerPage"
				hide-default-footer
			>

			<!-- 
			:items-per-page="itemsPerPage"
				hide-default-footer
				:page.sync="page" 
				@page-count="pageCount = $event"
			-->
			<!-- :search="search"
				:custom-filter="customFilter" -->
				<template v-slot:top>
					<v-toolbar flat>
						<v-toolbar-title>
							{{ (title in $vuetify.lang.locales.en ? $vuetify.lang.t('$vuetify.' + title) : title ) | capitalize }}
						</v-toolbar-title>

						<v-divider class="mx-4" inset vertical ></v-divider>

						<v-spacer></v-spacer>

						<v-menu
							v-model="menu.filter"
							:close-on-content-click="false"
							:nudge-width="200"
							offset-x
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" icon>
									<v-icon>mdi-filter-variant</v-icon>
								</v-btn>
							</template>

							<v-card>
								<v-card-title>Фільтр</v-card-title>
								<v-card-text>
									<v-list>
										<v-list-item>
											<v-list-item-action>
												<v-switch 
													v-model="onlymy"
													false-value="0"
													true-value="1"
												></v-switch>
											</v-list-item-action>
											<v-list-item-title>Тільки мої запити</v-list-item-title>
										</v-list-item>
									</v-list>

									<v-combobox v-if="isAdmin"
										v-model="organization"
										:items="organizations"
										label="Організація"
										dense
										outlined
										item-text="name"
										item-value="id"
										:loading="loadings.organization"
										@focus="loadOrganizations"
									></v-combobox>

									<v-text-field
										v-model.number="itemsPerPage"
										prepend-icon_="mdi-book-open-page-variant"
										label="Кількість рядків на сторінку"
										dense
										hide-details="auto"
										outlined
										type="number"
										:min="10"
										:max="100"
									></v-text-field>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn text @click="menu.filter = false">Cancel</v-btn>
									<v-btn color="primary" text @click="onFilter">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>

						<v-text-field
							v-model="search"
							append-icon="mdi-magnify"
							label="Пошук"
							dense
							single-line
							hide-details
							outlined
							rounded
						></v-text-field>

						<!-- <z-dialog-statistic :selected="selected"></z-dialog-statistic> -->
						<z-dialog-compare :selected="selected"></z-dialog-compare>
						<v-btn icon @click.stop="onRefresh">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>

						<!-- Пошук -->
						<!-- <z-search v-model="search"></z-search> -->
					</v-toolbar>
				</template>

				<template v-slot:[`item.actions`]="{ item }">
					<v-toolbar elevation="0" dense color="transparent">
						<!-- PDF -->
						<v-icon color="red" @click="onPDF(item)">mdi-file-pdf-box</v-icon>

						<!-- Редагувати -->
						<z-detail :selected="item"></z-detail>
						<!-- activator-type="button"
							activator-outlined
							:activator-title="$vuetify.lang.t('$vuetify.create')"
							activator-tooltip-disabled -->
						<!-- Видалити -->
						<!-- <z-confirm 
							activator-tooltip-text="delete"
							@ok="onDelete(item)"
						></z-confirm> -->
					</v-toolbar>
				</template>

				<template v-for="(item, index) in headers" v-slot:[`header.${item.value}`]="{  }">
					<span :key="index">{{ (item.text in $vuetify.lang.locales.en ? $vuetify.lang.t('$vuetify.' + item.text) : item.text ) | capitalize }}</span>
				</template>

				<template v-slot:[`item.number`]="{ item }">
					<span>{{ item.number }}{{ item.number && item.vin ? '/': ''}}{{ item.vin }}</span>
				</template>

				<template v-slot:[`item.datecreate`]="{ item }">
					<!-- <span>{{ item.datecreate | dd_mm_yyyy }}</span> -->
					<span>{{ item.datecreate | formatDateTime }}</span>
				</template>
				
				<template v-slot:[`item.icon`]="{ item }">
					<v-icon>{{ item.icon }}</v-icon>
				</template>

				<template v-slot:[`item.code`]="{ item }">
					<span>{{ avgStatisticUAH(item) }}</span>
				</template>
				<template v-slot:[`item.vin`]="{ item }">
					<span>{{ avgStatisticUSD(item) }}</span>
				</template>
				

				<!-- 
				valueUSD(items) {
					return items.map(element=>element.priceUSD);
				},

				
				avgUSD(items) {
					const arr = items.map(element=>element.priceUSD);
					const average = arr.reduce((a, b) => a + b, 0) / arr.length;
					return average
				}, -->

			</v-data-table>
			<!-- <div class="text-center pt-2">
				<v-pagination
					v-model="page"
					:length="pageCount"
					@next="onNext"
					@previous="onPrevious"
				></v-pagination>
			</div> -->

			<v-footer app padless>
				<v-card flat tile width="100%" class="text-center">
					<v-card-text>
						<!-- <v-btn icon @click="onPrevious">
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
						<v-btn text rounded>
							{{ page }}
						</v-btn>
						<v-btn icon @click="onNext">
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn> -->
						<v-pagination
							v-model="page"
							:length="pageCount"
							:total-visible="7"
							
						></v-pagination>
						<!-- @next="onNext"
							@previous="onPrevious" -->
					</v-card-text>
      			</v-card>
			</v-footer>

			<zPdfVehicleAutoAdvert ref="AutoAdvert" :item="pdfItem"></zPdfVehicleAutoAdvert>
			<zPdfVehicleAutoParams ref="AutoParams" :item="pdfItem"></zPdfVehicleAutoParams>
			<zPdfVehicleEquipment ref="AutoEquipment" :item="pdfItem"></zPdfVehicleEquipment>
			<zPdfVehicleEstimateExploration ref="exploration" :item="pdfItem"></zPdfVehicleEstimateExploration>
			<zPdfVehicleEstimateExpress ref="VehicleEstimateExpress" :item="pdfItem"></zPdfVehicleEstimateExpress>
			<zPdfVehicleAveragePriceAI ref="VehicleAveragePriceAI" :item="pdfItem"></zPdfVehicleAveragePriceAI>
			<zPdfVehicleAveragePriceCombo ref="AveragePriceCombo" :item="pdfItem"></zPdfVehicleAveragePriceCombo>
			<zPdfVehicleAveragePriceMediana ref="AveragePriceMediana" :item="pdfItem"></zPdfVehicleAveragePriceMediana>
			<zPdfVehicleAveragePriceStatistic ref="averagepricestatistic" :item="pdfItem"></zPdfVehicleAveragePriceStatistic>
			<z-pdf ref="pdf" :item="pdfItem"></z-pdf>

			<!-- <component v-bind:is="getComponentPdf(item.type.code)"
				ref="pdf"
				:selected="pdfItem"
			></component> -->

		<!-- </v-container> -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
    </v-main>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zPdf from '@/views/pdf/VehicleEstimate'

import zPdfVehicleAutoAdvert from '@/views/pdf/VehicleAutoAdvert'
import zPdfVehicleAutoParams from '@/views/pdf/VehicleAutoParams'
import zPdfVehicleEquipment from '@/views/pdf/VehicleEquipment'
import zPdfVehicleEstimateExploration from '@/views/pdf/VehicleEstimateExploration'
import zPdfVehicleEstimateExpress from '@/views/pdf/VehicleEstimateExpress'
import zPdfVehicleAveragePriceAI from '@/views/pdf/VehicleAveragePriceAI'
import zPdfVehicleAveragePriceCombo from '@/views/pdf/VehicleAveragePriceCombo'
import zPdfVehicleAveragePriceMediana from '@/views/pdf/VehicleAveragePriceMediana'
import zPdfVehicleAveragePriceStatistic from '@/views/pdf/VehicleAveragePriceStatistic'

import zDetail from '@/views/VehicleRequestDetail'
import zDialogCompare from '@/views/VehicleRequestCompare'
import zDialogStatistic from '@/views/VehicleRequestStatistic'

//import zConfirmDelete from '@/views/components/confirm-delete'

export default {
	name: 'VehicleRequest',
	mixins: [mixin],
	components: {
		zPdf,
		zPdfVehicleAutoAdvert,
		zPdfVehicleAutoParams,
		zPdfVehicleEquipment,
		zPdfVehicleEstimateExploration,
		zPdfVehicleEstimateExpress,
		zPdfVehicleAveragePriceAI,
		zPdfVehicleAveragePriceCombo,
		zPdfVehicleAveragePriceMediana,
		zPdfVehicleAveragePriceStatistic,
		downloadExcel,
		zDetail,
		zDialogCompare,
		zDialogStatistic
	},
	data: () => ({
		title: 'Запити',
		//loading: 	false,
		search: '',
		onlymy: 0, // ознака відображати тільки мої запити
		organization: null,

		loadings: {
			organization: false,
		},

		menu: {
			filter: 	false,
		},

		page: 1,
		pageCount: 2,
		itemsPerPage: 15,

		headers: [
			{ text: 'ID', value: 'id', sortable: true, width: '50'},
			{ text: 'Назва', value: 'type.name', sortable: true},
			{ text: 'Номер/VIN', value: 'number', sortable: true},
			//{ text: 'Vin', value: 'vin', sortable: true},
			{ text: 'Марка', value: 'brand.name', sortable: true},
			{ text: 'Модель', value: 'model.name', sortable: true},
			{ text: 'Ідентифікація', value: 'registrations.length', sortable: true},
			{ text: "Об'яви", value: 'estimates[0].adverts.length', sortable: true},
			{ text: "Комплектація", value: 'estimates[0].equipments.length', sortable: true},
			{ text: "Середня ціна в UAH Статистика", value: 'code', sortable: true},
			{ text: "Середня ціна в USD Статистика", value: 'vin', sortable: true},
			//{ text: "Середня ціна Статистика", value: 'estimates[0].prices.length', sortable: true},
			//{ text: "Середня ціна в UAH", value: 'avgPriceUAH', sortable: true},
			//{ text: "Середня ціна в USD встановлена", value: 'avgPriceUSD', sortable: true},
			{ text: "Середня ціна в UAH AI", value: 'estimates[0].avgPriceUAH', sortable: true},
			{ text: "Середня ціна в USD AI", value: 'estimates[0].avgPriceUSD', sortable: true},
			{ text: "Період оцінки", value: 'period', sortable: true},
			//{ text: "Відкоригована вартість в UAH", value: 'costAmvUAH', sortable: true},
			//{ text: 'Використання', value: 'uses.length', sortable: true},
			{ text: 'Створив', value: 'user.name', sortable: true},
			//{ text: 'Організація', value: 'user.profile.organization.name', sortable: true},
			{ text: 'Організація', value: 'user.profile.organization.alternateName', sortable: true},
			{ text: 'Дата', value: 'datecreate', sortable: true},
			{ text: 'Actions', value: 'actions', sortable: false, width: '10%' },
		],

		pdfItem: {},
	}),

	props: {
		own: { type: Boolean, default: false },
	},
	
	computed: {
		...mapGetters('VehicleRequest', [ 'endpoint', 'items' ]),
		...mapGetters('Organization', { organizations: 'items' }),

		...mapGetters(['roles']),

		isAdmin() {
			return this.roles.includes('ADMIN')
		},
	},

	watch: {
		page: function (val) {
			this.onSearch()
		},
	},

	/* created() {
		const requireComponent = require.context("@/views/pdf", false, /[A-Z]\w+\.(vue|js)$/);
		requireComponent.keys().forEach(fileName => {
			const componentConfig = requireComponent(fileName);
			const componentName = `zPdf${fileName.split("/").pop().split(".")[0]}`;
			this.$options.components[componentName] = componentConfig.default;
		});
	}, */

	methods: {
		...mapActions('VehicleRequest', [ 'setItem', 'setItems', 'createItem', 'updateItem', 'deleteItem' ]),
		...mapActions('Organization', { 'loadOrganization': 'load' }),

		loadOrganizations(e) {
			if(this.organizations.length == 0) {
				this.loadings.organization = true
				this.loadOrganization().then(() => {
				}).finally(() => (this.loadings.organization = false));
			}
		},

		/**
		 * Оновити
		 */
		onRefresh () {
			this.onSearch()	
		},

		onFilter () {
			this.menu.filter = false
			this.onSearch()	
		},

		onPDF (item) {
			//console.log(this.$options.name, 'onPDF','item', item)

			this.pdfItem = item

			if(this.$refs.hasOwnProperty(item.type.code)) {
				//this.$refs[item.type.code].generate(item)
				this.$refs[item.type.code].generate()
			} else {
				this.$refs.pdf.generate()
			}
		},

		onNext() {
			//console.log(this.$options.name, 'onNext','page', this.page)
			//this.page++
			this.onSearch()
		},

		onPrevious() {
			/* if(this.page > 1) {
				this.page--
				this.onSearch()
			} */
			//console.log(this.$options.name, 'onPrevious','page', this.page)
			this.onSearch()
		},

		/**
		 * Пошук
		 */
		onSearch () {
			//console.log(that.$options.name, 'search')

			let params = {
				page: this.page,
				itemsPerPage: this.itemsPerPage,
				onlymy: this.onlymy,
				organization: this.organization?.id,
			}

			//console.log(this.$options.name, 'search','params', params)

			this.loading = true
			var that = this
			/* var p = this.own ? axios.get(`vehicle/myrequest`, { params: params }) : axios.get(`vehicle/request`, { params: params })
			p.then(response => {
				//console.log(that.$options.name, 'onSearch','response', response)
				//console.log(that.$options.name, 'onSearch','response.headers', response.headers)
				//console.log(that.$options.name, 'onSearch','response.headers.pagecount', response.headers.pagecount)
				//console.log(that.$options.name, 'onSearch','response.data', response.data)
				that.setItems()
				that.setItems(response.data)

				if(that.items.length > 0 && that.pageCount < that.page + 1) {
					that.pageCount = that.page + 1
				}
			}, error => {
				console.log(error)
			}).finally(() => {
				this.loading = false
			}); */

			axios.get(`/vehicle/request`, { params: params }).then(response => {
				//console.log(this.$options.name, 'search','response.data', response.data)
				that.setItems()
				that.setItems(response.data)
				if(that.items.length > 0 && that.pageCount < that.page + 1) {
					that.pageCount = that.page + 1
				}
			}, error => {
				//console.log(error)
				//that.showMessage(error)
			}).finally(() => (this.loading = false));
		},

		valueUSD(items) {
			return items.map(element=>element.priceUSD);
		},
		
		avgStatisticUSD(item) {
			//if(item && item.estimates)
			//item?.estimates[0]?.prices
			let items = item?.estimates[0]?.prices ? item.estimates[0].prices : [] 
			const arr = items.map(element=>element.priceUSD);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average ? Math.floor(average) : ''
		},

		avgStatisticUAH(item) {
			let items = item?.estimates[0]?.prices ? item.estimates[0].prices : []
			const arr = items.map(element=>element.priceUAH);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average ? Math.floor(average) : ''
		},

		/* avgUSD(items) {

			item?.estimates[0]?.prices

			const arr = items.map(element=>element.priceUSD);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average ? average : ''
		},

		avgUAH(items) {
			const arr = items.map(element=>element.priceUAH);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average ? average : ''
		}, */
	},
}
</script>